export enum PoolingKeys {
  LaborStage = "LABOR_STAGE",
  Postpartum = "POSTPARTUM",
  EncounterPhysicalExams = "ENCOUNTER_PHYSICAL_EXAMS",
  ClientProblems = "CLIENT_PROBLEMS",
}
